import * as types from './actionTypes';

export function setProviderShowForm(payload) {
  return { type: types.SET_PROVIDER_SHOW_FORM, payload };
}

export function setPhysicianShowForm(payload) {
  return { type: types.SET_PHYSICIAN_SHOW_FORM, payload };
}